module.exports = __webpack_public_path__ + "img/env.3c3a456.png";